import React from 'react';

const SoonIcon = () => {
  return (
    <div>
      <svg
        width='98'
        height='99'
        viewBox='0 0 98 99'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_111_2916)'>
          <rect
            y='0.5'
            width='97.6934'
            height='97.6934'
            rx='48.8467'
            fill='currentColor'
          />
          <path
            d='M31.9394 59.0077H27.1087C26.4681 59.0077 25.8538 59.2622 25.4008 59.7151C24.9478 60.1681 24.6934 60.7825 24.6934 61.423V62.6307C24.6934 63.2713 24.9478 63.8856 25.4008 64.3386C25.8538 64.7916 26.4681 65.046 27.1087 65.046H29.524C30.1646 65.046 30.779 65.3005 31.2319 65.7535C31.6849 66.2064 31.9394 66.8208 31.9394 67.4614V68.669C31.9394 69.3096 31.6849 69.924 31.2319 70.3769C30.779 70.8299 30.1646 71.0844 29.524 71.0844H24.6934M73 59.0077V71.0844L64.5463 59.0077V71.0844M40.393 59.0077H42.8083C43.4489 59.0077 44.0633 59.2622 44.5162 59.7151C44.9692 60.1681 45.2237 60.7825 45.2237 61.423V68.669C45.2237 69.3096 44.9692 69.924 44.5162 70.3769C44.0633 70.8299 43.4489 71.0844 42.8083 71.0844H40.393C39.7524 71.0844 39.1381 70.8299 38.6851 70.3769C38.2322 69.924 37.9777 69.3096 37.9777 68.669V61.423C37.9777 60.7825 38.2322 60.1681 38.6851 59.7151C39.1381 59.2622 39.7524 59.0077 40.393 59.0077ZM53.6773 59.0077H56.0927C56.7333 59.0077 57.3476 59.2622 57.8006 59.7151C58.2535 60.1681 58.508 60.7825 58.508 61.423V68.669C58.508 69.3096 58.2535 69.924 57.8006 70.3769C57.3476 70.8299 56.7333 71.0844 56.0927 71.0844H53.6773C53.0368 71.0844 52.4224 70.8299 51.9694 70.3769C51.5165 69.924 51.262 69.3096 51.262 68.669V61.423C51.262 60.7825 51.5165 60.1681 51.9694 59.7151C52.4224 59.2622 53.0368 59.0077 53.6773 59.0077ZM60.9233 39.6851C60.9233 36.4821 59.651 33.4104 57.3862 31.1456C55.1214 28.8808 52.0496 27.6084 48.8467 27.6084C45.6437 27.6084 42.572 28.8808 40.3072 31.1456C38.0424 33.4104 36.77 36.4821 36.77 39.6851C36.77 42.888 38.0424 45.9597 40.3072 48.2245C42.572 50.4894 45.6437 51.7617 48.8467 51.7617C52.0496 51.7617 55.1214 50.4894 57.3862 48.2245C59.651 45.9597 60.9233 42.888 60.9233 39.6851Z'
            stroke='#FEFEFE'
            stroke-width='1.68023'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
          <path
            d='M52.4697 40.8925L48.8467 39.6848V33.6465'
            stroke='#FEFEFE'
            stroke-width='1.68023'
            stroke-linecap='round'
            stroke-linejoin='round'
          />
        </g>
        <defs>
          <filter
            id='filter0_i_111_2916'
            x='0'
            y='0.5'
            width='97.6934'
            height='99.6934'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dy='2' />
            <feGaussianBlur stdDeviation='3' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_111_2916'
            />
          </filter>
        </defs>
      </svg>
    </div>
  );
};

export default SoonIcon;
